import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Scheduling } from '../scheduling/scheduling';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class SchedulingService {

  private schedulesUrl = '/api/schedulings';
  private scheduleTimesUrl = '/api/schedulingtimes';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  findByDoctorDate(doctor_id: number, date: Date): Observable<Scheduling[]> {
    return this.http
      .get<Scheduling[]>(`${this.schedulesUrl}/?doctor_id=${doctor_id}&date=${date}`, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  findByDoctorPatientDate(doctor_id: number, patient_id: number, date: Date): Observable<Scheduling[]> {
    return this.http
      .get<Scheduling[]>(`/api/scheduling/?doctor_id=${doctor_id}&patient_id=${patient_id}&date=${date}`, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getAvailableTimesByDoctorDate(doctor_id: number, date: Date): Observable<[]> {
    return this.http
      .get<[]>(`${this.scheduleTimesUrl}/?doctor_id=${doctor_id}&date=${date}`, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createScheduling(scheduling: Scheduling): Observable<Scheduling> {
    return this.http
      .post<Scheduling>(this.schedulesUrl, scheduling, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updateScheduling(scheduling: Scheduling): Observable<Scheduling> {
    return this.http
      .put<Scheduling>(this.schedulesUrl, scheduling, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  deleteScheduling(id: number): Observable<Scheduling> {
    return this.http
      .delete(`${this.schedulesUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
